export default __webpack_public_path__ + "static/media/wildsee_hut.228452b5.jpg";